//imports
import { all } from 'redux-saga/effects';

import statementReportSagas from '../../list/redux/sagas';

//merge sagas
export default function* rootSaga() {
    yield all([
        statementReportSagas(),
    ]);
}
